import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { FinancialYearModel } from "src/app/model/FinancialYearModel";
import { Page } from "src/app/model/Page";
import { ApiUrls } from "src/app/services/ApiUrls";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-financial-year-list",
  templateUrl: "./financial-year-list.component.html",
  styleUrls: ["./financial-year-list.component.scss"],
})
export class FinancialYearListComponent implements OnInit {
  page: Page<FinancialYearModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  projectImagesUrl: string;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<FinancialYearModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "financialYear",
    "assessmentYear",
    "displayOrder",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.projectImagesUrl = ApiUrls.projectImagesUrl;
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService.fetchFinancialYearList(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
      this.page = page;
      this.dataSource = new MatTableDataSource(page.content);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = page.totalElements;
      });
      this.isSearchDisabled = false;
      this.isLoading = false;
    },
    (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onLoad();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Financial Year", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  edit(key: number) {
    this.router.navigate(['/secure', 'financial-year', 'au', key]);
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate the Financial Year")) {
      this.masterService.toggleActivationFinancialYear(key, 'N').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'N';
        }
        else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
    } 
  }
 
  activate(key: number) {
    if(confirm("Do you want to Activate the Financial Year")) {
      this.masterService.toggleActivationFinancialYear(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
        }
        else {
          this.masterService.errorToast(data.errorMessage);
        }
      });
    } 
  }
    
}